import { Rating } from '@mui/material';

interface StarRatingProps {
  value: number | null;
  readOnly?: boolean;
  onChange?: (newValue: number | null) => void;
  size?: 'small' | 'medium' | 'large';
}

const StarRating = ({ value, readOnly = true, onChange, size = 'medium' }: StarRatingProps) => {
  const displayValue = value !== null ? value / 2 : null;

  const handleChange = (_event: React.SyntheticEvent, newDisplayValue: number | null) => {
    if (onChange) {
      const newTastiness = newDisplayValue !== null ? newDisplayValue * 2 : null;
      onChange(newTastiness);
    }
  };

  return (
    <Rating
      value={displayValue}
      readOnly={readOnly}
      onChange={readOnly ? undefined : handleChange}
      precision={0.5}
      size={size}
    />
  );
};

export default StarRating;
